import React, {useEffect, useState} from "react";

import './EditAlertReadmeModal.scss'
import {Modal, TextArea, TextAreaSkeleton} from "@carbon/react";
import {useRecoilValue} from "recoil";
import {grpcAlarmServiceSelector, grpcDeviceServiceSelector} from "../../../state/grpc";
import {ADD, useToastContext} from "../../Toast";
import PropTypes from "prop-types";

const EditAlertReadmeModal = (props) => {
  const isOpen = props.isOpen
  const onClose = props.onClose
  const alarm = props.alarm

  const { toastDispatch } = useToastContext();
  const [loading, setLoading] = useState(true)
  const [deviceAlarm, setDeviceAlarm] = useState(null)
  const deviceService = useRecoilValue(grpcDeviceServiceSelector)
  const alarmService = useRecoilValue(grpcAlarmServiceSelector)

  useEffect(() => {
    if (!isOpen || !alarm) {
      return
    }
    setLoading(true)
    const req = new proto.api.FindDeviceAlarmsRequest()
    req.setSystemCode(alarm.customerCode)
    req.setDeviceCode(alarm.instrumentCode)
    req.setAlarmCode(alarm.code)
    deviceService.findDeviceAlarm(req, null, (err, resp) => {
      if (err == null) {
        setDeviceAlarm(resp.toObject().devicealarm)
        setLoading(false)
      } else {
        console.error(err)
      }
    })
  }, [alarm]);

  if (!isOpen || !alarm) {
    return <></>
  }

  const updateAlarmReadme = async () => {
    const req = new proto.api.UpdateAlarmRequest()
    const alarmReq = new proto.api.Alarm()
    alarmReq.setId(alarm.id)
    alarmReq.setReadme(deviceAlarm.readme)
    req.setAlarm(alarmReq)
    alarmService.updateAlarm(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
      }
    })
  }

  return (
    <Modal
      open={isOpen}
      modalHeading="Modifica le indicazioni dell'allarme"
      modalLabel="Dati allarme"
      primaryButtonText="Salva"
      secondaryButtonText="Annulla"
      onRequestSubmit={() => {
        const req = new proto.api.SaveDeviceAlarmRequest()
        const deviceAlarmReq = new proto.api.DeviceAlarm()
        deviceAlarmReq.setId(deviceAlarm.id)
        deviceAlarmReq.setDeviceId(deviceAlarm.deviceId)
        deviceAlarmReq.setReadme(deviceAlarm.readme)
        req.setDevicealarm(deviceAlarmReq)
        console.log(req)
        deviceService.updateDeviceAlarm(req, null, (err, resp) => {
          if (err != null) {
            console.error(err)
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione fallita",
                content: "Impossibile salvare le indicazioni. Riprova più tardi",
                kind: "error",
                caption: err.message
              }
            })
          } else {
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione completata con successo",
                content: "Indicazioni allarme salvate con successo",
                kind: "success"
              }
            })
            updateAlarmReadme().then(() => onClose(true, deviceAlarm.readme))
          }
        })
      }}
      onRequestClose={() => onClose(false, "")}>

      <p style={{marginBottom: '1rem'}}>
        Puoi scrivere un testo lungo a piacere. Queste indicazioni verranno salvate in tutti gli allarmi
        con lo stesso codice e strumento per questo cliente. Il testo sarà consultabile da qualsiasi
        altro utente dalla dashboard sul menu espandibile dell'allarme stesso, oppure dallo storico allarmi.
      </p>
      <br/>
      {
        loading && <TextAreaSkeleton />
      }
      {
        !loading &&
        <TextArea
          data-modal-primary-focus
          maxCount={1000}
          value={deviceAlarm.readme}
          onChange={ev => setDeviceAlarm({...deviceAlarm, readme: ev.target.value})}
          id="alarm-readme"
          labelText="Indicazioni allarme"
          style={{marginBottom: '1rem'}}
        />
      }
    </Modal>
  );
}

EditAlertReadmeModal.propTypes = {
  alarm: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default EditAlertReadmeModal